import { motion } from "framer-motion";
import {
  Handshake,
  RefreshCw,
  Rocket,
  ShoppingBag,
  TrendingUp,
  Workflow,
} from "lucide-react";
import "./BusinessAreaSection.css";

const SCENARIOS = [
  {
    id: "launch",
    n: "01",
    kr: "신규 서비스 런칭",
    tag: "MVP 기획부터 오픈까지",
    Icon: Rocket,
  },
  {
    id: "renewal",
    n: "02",
    kr: "기존 사이트·시스템 개편",
    tag: "리뉴얼과 구조 재설계",
    Icon: RefreshCw,
  },
  {
    id: "scale",
    n: "03",
    kr: "플랫폼 확장·고도화",
    tag: "트래픽·기능 확장 대응",
    Icon: TrendingUp,
  },
  {
    id: "automate",
    n: "04",
    kr: "운영·업무 자동화",
    tag: "AI·워크플로우 통합",
    Icon: Workflow,
  },
  {
    id: "commerce",
    n: "05",
    kr: "커머스·결제 연동",
    tag: "쇼핑몰·정기결제 구축",
    Icon: ShoppingBag,
  },
  {
    id: "partner",
    n: "06",
    kr: "장기 운영 파트너십",
    tag: "유지보수와 기능 확장",
    Icon: Handshake,
  },
];

export default function BusinessAreaSection() {
  return (
    <section
      id="business"
      data-testid="business-section"
      className="ds-partnership-section relative bg-[#0A2540] text-white py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 ds-dot-grid opacity-50" aria-hidden="true" />
      <div className="absolute -top-32 right-0 w-[40vw] h-[40vw] ds-glow opacity-60" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <div className="text-xs font-semibold tracking-[0.25em] uppercase text-white/60">
            Partnership — 06
          </div>
          <h2 className="font-display font-kr mt-5 text-4xl md:text-5xl font-bold tracking-tight leading-[1.1]">
            이런 상황에서<br />함께합니다.
          </h2>
        </motion.div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {SCENARIOS.map((item, i) => (
            <motion.article
              key={item.id}
              data-testid={`business-card-${item.id}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="ds-partnership-card group"
            >
              <div className="ds-partnership-card__inner">
                <div className="flex items-start justify-between gap-4">
                  <div className="ds-partnership-card__icon">
                    <item.Icon size={20} strokeWidth={1.6} />
                  </div>
                  <span className="font-display text-sm font-semibold text-slate-300 tracking-tight">
                    {item.n}
                  </span>
                </div>

                <h3 className="font-kr mt-8 text-xl md:text-[22px] font-bold tracking-tight text-slate-900 leading-snug">
                  {item.kr}
                </h3>
                <p className="font-kr mt-3 text-sm text-slate-500 leading-relaxed [word-break:keep-all]">
                  {item.tag}
                </p>

                <div className="ds-partnership-card__line" aria-hidden="true" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
